export const tabColumns = (
  { hasCollege, hasCountry, hasProgramWebSite, hasProjectTrait, hasRankUsnews, hasQSRank, hasOtherInfo, hasCaseInfo, hasBranchInfo, hasMajorRankUsnews },
  the
) => {
  let arr = []
  if (hasRankUsnews) {
    arr.push({
      title: 'USNews综排',
      width: 120,
      align: 'center',
      render: (h, params) => {
        return h('span', params.row.overseasBasicInfo.rank_USNEWS)
      }
    })
  }
  if (hasMajorRankUsnews) {
    arr.push({
      title: '专排',
      width: 120,
      align: 'center',
      render: (h, params) => {
        let data = params.row.overseasBasicInfo.majorRank_USNEWS
        return h('span', {
          attrs: {
            title: data
          }
        }, data)
      }
    })
  }
  if (hasQSRank) {
    arr.push({
      title: 'QS排名',
      width: 100,
      align: 'center',
      render: (h, params) => {
        return h('span', params.row.overseasBasicInfo.qsRank)
      }
    })
  }
  if (hasCountry) {
    arr.push({
      title: '国家/地区',
      width: 100,
      align: 'center',
      render: (h, params) => {
        return h('span', params.row.overseasBasicInfo.country)
      }
    })
  }
  if (hasCollege) {
    arr.push({
      title: '学院',
      width: 180,
      align: 'center',
      render: (h, params) => {
        return h('span', params.row.overseasBasicInfo.college)
      }
    })
  }
  if (hasProgramWebSite) {
    arr.push({
      title: '项目链接',
      width: 250,
      align: 'center',
      render: (h, params) => {
        return h(
          'a',
          {
            attrs: {
              href: params.row.overseasBasicInfo.programWebSite,
              target: '_blank'
            }
          },
          params.row.overseasBasicInfo.programWebSite
        )
      }
    })
  }
  if (hasProjectTrait || hasOtherInfo || hasCaseInfo) {
    arr.push({
      title: '项目特点',
      width: 100,
      align: 'center',
      render: (h, params) => {
        return h(
          'span',
          {
            style: {
              color: '#6589dd',
              cursor: 'pointer'
            },
            on: {
              click: () => {
                the.$refs['projectCharacteristic'].show(
                  [
                    {
                      isShow: hasProjectTrait,
                      title: '基本信息',
                      value: params.row.overseasBasicInfo.projectTrait
                    },
                    {
                      isShow: hasOtherInfo,
                      title: '特殊信息',
                      value: params.row.overseasBasicInfo.otherInfo
                    },
                    {
                      isShow: hasCaseInfo,
                      title: '案例信息',
                      value: params.row.overseasBasicInfo.caseInfo
                    }
                  ]
                )
              }
            }
          },
          (params.row.overseasBasicInfo.projectTrait || params.row.overseasBasicInfo.otherInfo || params.row.overseasBasicInfo.caseInfo) ? '查看' : ''
        )
      }
    })
  }
  // if (hasProjectTrait) {
  //   arr.push({
  //     title: '基本信息',
  //     width: 160,
  //     align: 'center',
  //     render: (h, params) => {
  //       return h(
  //         'span',
  //         {
  //           style: {
  //             color: '#6589dd',
  //             cursor: 'pointer'
  //           },
  //           on: {
  //             click: () => {
  //               the.$refs['projectCharacteristic'].show(
  //                 params.row.overseasBasicInfo.projectTrait
  //               )
  //             }
  //           }
  //         },
  //         params.row.overseasBasicInfo.projectTrait ? '查看' : ''
  //       )
  //     }
  //   })
  // }
  // if (hasOtherInfo) {
  //   arr.push({
  //     title: '特殊信息',
  //     width: 160,
  //     align: 'center',
  //     render: (h, params) => {
  //       return h(
  //         'span',
  //         {
  //           style: {
  //             color: '#6589dd',
  //             cursor: 'pointer'
  //           },
  //           on: {
  //             click: () => {
  //               the.$refs['projectCharacteristic'].show(
  //                 params.row.overseasBasicInfo.otherInfo
  //               )
  //             }
  //           }
  //         },
  //         params.row.overseasBasicInfo.otherInfo ? '查看' : ''
  //       )
  //     }
  //   })
  // }
  // if (hasCaseInfo) {
  //   arr.push({
  //     title: '案例信息',
  //     width: 160,
  //     align: 'center',
  //     render: (h, params) => {
  //       return h(
  //         'span',
  //         {
  //           style: {
  //             color: '#6589dd',
  //             cursor: 'pointer'
  //           },
  //           on: {
  //             click: () => {
  //               the.$refs['projectCharacteristic'].show(
  //                 params.row.overseasBasicInfo.caseInfo
  //               )
  //             }
  //           }
  //         },
  //         params.row.overseasBasicInfo.caseInfo ? '查看' : ''
  //       )
  //     }
  //   })
  // }
  if (hasBranchInfo) {
    arr.push({
      title: '分支方向',
      width: 160,
      align: 'center',
      render: (h, params) => {
        return h(
          'span',
          {
            style: {
              color: '#6589dd',
              cursor: 'pointer'
            },
            on: {
              click: () => {
                the.$refs['projectCharacteristic'].show(
                  params.row.overseasBasicInfo.branchDirection
                )
              }
            }
          },
          params.row.overseasBasicInfo.branchDirection ? '查看' : ''
        )
      }
    })
  }
  return arr
}
